module.exports = __webpack_public_path__ + "static/img/icon1.6ca7fa43.svg";